namespace $ { $mol_style_attach( "bog/ui/empty/empty.view.css",
 "[bog_ui_empty] {\n\tpadding: clamp(1rem, 5%, 3rem);\n}\n\n[bog_ui_empty] > [bog_ui_empty_icon] {\n\tfont-size: clamp(2rem, 8vw, 4rem);\n}\n\n[bog_ui_empty] > [bog_ui_empty_message] {\n\tmax-width: min(100%, 400px);\n}\n"
) }